import React from 'react';

import { Grid, Section } from '@gogame/components';
import { SidePageV2, FormField, withForm } from '@gogame/form';

import {
  loadEvents,
  loadApplications,
  loadNetworks,
  loadAffiliates,
  loadPlatforms,
  loadTrafficTypes,
  loadActivityTypes,
  loadRegistrationCountries,
  loadEventCountries,
  loadChannels,
} from 'scenes/Integrations/sources/conversions/fields';
import {
  getOptionValueInteger,
  getOptionLabelInteger,
  getOptionIdentity,
} from 'scenes/Integrations/utils';

import ConversionInfo from './ConversionInfo';
import {
  EVENT,
  APPLICATION,
  NETWORK,
  AFFILIATES,
  CAMPAIGNS,
  REG_PLATFORM,
  EVENT_PLATFORM,
  TRAFFIC_TYPE,
  IS_INCLUDE_REJECTED_REGS,
  CONVERSION_INFO,
  SENDING_DELAY,
  IS_ACTIVE,
  ACTIVITY_TYPE,
  RE_PLATFORM,
  REGISTRATION_COUNTRIES,
  EVENT_COUNTRIES,
  CHANNELS,
  TRAFFIC_TYPE_AFFILIATES,
} from './constants';
import { conversionSchema } from './schemas';

const IntegrationConversionForm = withForm({
  enableReinitialize: true,
  validationSchema: conversionSchema,
})(({
  children,
  title,
  subTitle,
  loading,
  onClose,
  onExited,
  open,
  values,
}) => {
  const { [TRAFFIC_TYPE]: trafficType } = values;

  const trafficTypeAffiliates = trafficType === TRAFFIC_TYPE_AFFILIATES;

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} />
      <SidePageV2.NewBody>
        <Section title={'General'}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <FormField.Select
                label={'Event'}
                name={EVENT}
                source={loadEvents}
                lazy={true}
                required={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Event platform'}
                name={EVENT_PLATFORM}
                source={loadPlatforms}
                lazy={true}
                padding={0}
                withDeselectButton={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Application'}
                name={APPLICATION}
                source={loadApplications}
                lazy={true}
                required={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Network'}
                name={NETWORK}
                source={loadNetworks}
                lazy={true}
                withDeselectButton={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Reg platform'}
                name={REG_PLATFORM}
                source={loadPlatforms}
                lazy={true}
                padding={0}
                withDeselectButton={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Targeting platform'}
                name={RE_PLATFORM}
                source={loadPlatforms}
                lazy={true}
                padding={0}
                withDeselectButton={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.MultiSelect
                label={'Registration countries'}
                name={REGISTRATION_COUNTRIES}
                source={loadRegistrationCountries}
                withAll={true}
                lazy={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.MultiSelect
                label={'Event / user countries'}
                name={EVENT_COUNTRIES}
                source={loadEventCountries}
                withAll={true}
                lazy={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.MultiSelect
                label={'Excluded channels'}
                name={CHANNELS}
                source={loadChannels}
                lazy={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <Section title={'Traffic type'}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormField.RadioGroup
                      name={TRAFFIC_TYPE}
                      radioVertical={true}
                      source={loadTrafficTypes}
                      padding={0}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField.MultiSelect
                      label={'Select affiliates'}
                      name={AFFILIATES}
                      source={loadAffiliates}
                      disabled={!trafficTypeAffiliates}
                      withAll={true}
                      lazy={true}
                      padding={0}
                    />
                  </Grid>
                </Grid>
              </Section>
            </Grid>
            <Grid item xs={4}>
              <Section title={'Activity Type'}>
                <FormField.RadioGroup
                  name={ACTIVITY_TYPE}
                  radioVertical={true}
                  source={loadActivityTypes}
                  padding={0}
                />
              </Section>
            </Grid>
            <Grid item xs={4}>
              <Section title={'Regs'}>
                <FormField.Checkbox
                  label={'Include rejected'}
                  name={IS_INCLUDE_REJECTED_REGS}
                  padding={0}
                />
              </Section>
            </Grid>
            {trafficTypeAffiliates ? (
              <Grid item xs={12}>
                <FormField.ChipsInput
                  label={'Campaigns IDs'}
                  name={CAMPAIGNS}
                  padding={0}
                  freeSolo={true}
                  autoSelect={true}
                  plainValue={true}
                  getOptionValue={getOptionValueInteger}
                  getOptionLabel={getOptionLabelInteger}
                  createOption={getOptionIdentity}
                />
              </Grid>
            ) : null}
          </Grid>
        </Section>
        <Section title={'Sending Delay'}>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <FormField.TextField
                name={SENDING_DELAY}
                type={'number'}
                placeholder={'0'}
                padding={0}
              />
            </Grid>
          </Grid>
        </Section>
        <Section title={'Conversion Info'}>
          <Grid container spacing={3} alignItems={'center'}>
            <ConversionInfo name={CONVERSION_INFO} />
          </Grid>
        </Section>
        <Section title={'Status'}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <FormField.Checkbox
                label={'Active'}
                name={IS_ACTIVE}
                padding={0}
              />
            </Grid>
          </Grid>
        </Section>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {children}
    </SidePageV2>
  );
});

export default IntegrationConversionForm;
